const routes = [
  {
    path: '/secrets',
    component: () => import('./1index.vue'),
  },
];

export default routes;
